module.exports = __webpack_public_path__ + "static/media/RnR-setup-complete-msteams.84f0da60.svg";